import React, { Component } from "react";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect } from "react-router-dom";
import Card from "components/Card/Card.js";
import EditIcon from "@material-ui/icons/Edit";
import CardHeader from "components/Card/CardHeader.js";
import axios from "axios";
import Loader from "components/Loader";
import Notification from "components/Notification";
import CardIcon from "components/Card/CardIcon.js";
import Constants from "../variables/Constants";
import CardBody from "components/Card/CardBody.js";

class MarkAttendanceAutomation extends Component {
  state = {
    mobile_no: "",
    strategy_day_status: "",
    strategy_days_id: "",
    redirect: false,
    type: "success",
    message: "",
    notification: false,
    loading: false,
  };

  componentDidMount() {
    axios.get(Constants.getUrls.showAttendanceAutomation).then((resp) => {
      console.log("Attendence Data", resp);
      this.setState({
        mobile_no: resp.data.mobile_no || "",
        strategy_day_status: resp.data.strategy_day_status || "",
        strategy_days_id: resp.data.strategy_days_id || "",
      });
    });
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { mobile_no, strategy_day_status, strategy_days_id } = this.state;

    if (!mobile_no || !strategy_day_status || !strategy_days_id) {
      this.setState({
        notification: true,
        type: "warning",
        message: "All fields are required!",
        loading: false,
      });

      setTimeout(() => this.setState({ notification: false }), 2000);
      return;
    }

    this.setState({ loading: true });

    const payLoad = { mobile_no, strategy_day_status, strategy_days_id };

    axios
      .post(Constants.postUrls.addAttendanceAutomation, payLoad)
      .then((resp) => {
        const data = resp?.data;

        if (!data || data.status !== "success") {
          console.error("Error in response:", data?.message || resp);

          this.setState({
            notification: true,
            type: "error",
            message:
              data?.message || "Failed to update attendance. Please try again.",
            loading: false,
          });

          setTimeout(() => this.setState({ notification: false }), 2000);
          return;
        }

        this.setState({
          notification: true,
          type: "success",
          message: "Attendance Updated Successfully!",
          loading: false,
          mobile_no: "",
          strategy_day_status: "",
          strategy_days_id: "",
        });

        setTimeout(() => {
          this.setState({ notification: false });
        }, 2000);
      })
      .catch((error) => {
        console.error("Error adding attendance:", error);

        this.setState({
          notification: true,
          type: "error",
          message: "Something went wrong. Please try again.",
          loading: false,
        });

        setTimeout(() => this.setState({ notification: false }), 2000);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin//markattendance"} />;
    } else {
      return (
        <div>
          {this.state.notification ? (
            <Notification
              title={this.state.message}
              type={this.state.type}
              duration={3000}
            />
          ) : null}
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Mark Attendance Automation</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText="Mobile No"
                          inputProps={{
                            name: "mobile_no",
                            value: this.state.mobile_no,
                            onChange: this.handleInput,
                          }}
                          id="mobile_no"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText="Strategy Day Status"
                          inputProps={{
                            name: "strategy_day_status",
                            value: this.state.strategy_day_status,
                            onChange: this.handleInput,
                          }}
                          id="strategy_day_status"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          labelText="Strategy Days ID"
                          inputProps={{
                            name: "strategy_days_id",
                            value: this.state.strategy_days_id,
                            onChange: this.handleInput,
                          }}
                          id="strategy_days_id"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                    <GridItem xs={12} sm={12} md={5}>
                      <Button type="submit" color="info">
                        {this.state.loading ? <Loader /> : "Update"}
                      </Button>
                    </GridItem>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default MarkAttendanceAutomation;
